const removeQueryParamFromUrl = (name: string) => {
    const url = new URL(window.location.href);
    url.searchParams.delete(name);
    window.history.pushState({}, '', url.href);
};

export default removeQueryParamFromUrl;
